<template lang="pug">
  div(id="site-footer" :class="'container-'+this._uid")
    #infoContainer
      span.footerMeta
        h2.title
          vue-markdown(:source='this.title')
        span.subtitle
          vue-markdown(:source='this.desc')
      nav#footer-nav
        div.nav-items-container
          ol.nav-items
            li.item.button
              router-link(:to="{ name: 'pageScene', params: { page: 'courses' }}") Masterclasses
            //- li.item.button
            //-   a(href="mailto:info@digimaster.net") Contact
            //- li.item.button
            //-   a(href="mailto:info@digigurus.net") Privacy
    #newsletterContainer
      div.logo
      h6 Newsletter
      span

      mcSubscribe(action="https://digigurus.us16.list-manage.com/subscribe/post?u=09283e07454e068bd65340edd&amp;id=3d6aaf4c34")
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/sectionBase.js'
import mcSubscribe from '@/components/mcSubscribe.vue'
import anime from 'animejs'

// Storing animation target elements
const animTargets = {
  container: '#container'
}

// component instance
var pageFooter = Vue.component('page-footer', {
  name: 'pageFooter',
  mixins: [sectionBase],
  props: [],
  components: {mcSubscribe},
  data: function () {
    return {}
  },
  watch: {
  },
  methods: {
    handleSubmit (e) {
      console.log('submitting newsletter form', e)
    }
  },
  computed: {
    actions () {
      // let component = this

      return {
        SET: () => {
          return anime({
            targets: animTargets.container + this._uid,
            easing: 'easeInOutQuad',
            opacity: [
              { value: '1' }
            ],
            translateX: [
              { value: 0 }
            ],
            translateY: [
              { value: 0 }
            ],
            borderColor: [
              { value: '#F0F0F0' }
            ],
            boxShadow: [
              { value: '0px 0px 10px rgba(211,211,211,1)' }
            ],
            duration: 200,
            begin: function (e) {
              console.log('set')
            },
            complete: function () {
            }
          })
        }
      }
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default pageFooter
</script>

<style lang="scss" scoped>
  h4, h5, h6{
    position: relative;
    color: #fff;

    margin-bottom: 2rem;

    &:after{
      content: '';
      display: block;
      position: absolute;
      width: 34px;
      height: 1px;

      bottom: -10px;
      left: 0;

      background-color: #fff;
      opacity: .6;
    }
  }
  a{
    color: #fff;
    text-decoration: underline;
  }

  #site-footer{
    padding: 3rem $body-gutter;
    display: flex;
    flex-direction: row;

    color: #DEDEFF;
    font-size: 90%;

    @include breakpoint(small only){
      flex-direction: column;
    }
  }

  #infoContainer{
    flex: 1;

    margin-bottom: 4rem;

    .footerMeta{
      // opacity: .6;
      display: block;
      margin-bottom: 2rem;

      line-height: 1.4;

      .title{
        text-transform: uppercase;
        color: #fff;
      }
      .subtitle{
        display: inline-block;
        text-transform: none;
        max-width: 340px
      }
    }
  }
  #newsletterContainer{
    flex: 1;
  }
  #newsletter{
    position: relative;
    margin-top: 2rem;
    // margin-bottom: 2.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/sections/pageFooter.vue